import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { MaintenanceService } from './maintenance.service';
export const maintenanceInterceptor: HttpInterceptorFn = (request, next) => {
  const maintenance = inject(MaintenanceService);
  const url = new URL(request.url, typeof location === 'undefined' ? 'https://hobbyts.com' : location.origin);
  const api = url.host === environment.apiOrigin || url.pathname === '/graphql';
  if (!api) {
    return next(request);
  }
  if (maintenance.blocked()) {
    return throwError(() => new HttpErrorResponse({ status: 503, error: { code: 'MAINTENANCE' }, url: request.url }));
  }
  return next(request).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        maintenance.reportFailure(error.status, error.error);
      }
      return throwError(() => error);
    })
  );
};
